/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceProvider } from './resourceProvider';


export interface CWSRemediationSpec { 
    spec_type?: ResourceProvider;
    /**
     * CrowdStrike API Key ID
     */
    api_key_id: string;
    /**
     * CrowdStrike API Key Secret
     */
    api_key_secret: string;
}
export namespace CWSRemediationSpec {
}


